module.exports = __webpack_public_path__ + "img/puntonet.5bc367c4.png";